<template>
  <div class="home">
    <div class="home-nav">
      <a href="/">
        <img
          alt="洪恩教育"
          src="https://assets.hongen.com/wp-content/themes/base-hongen/img/logo.png"
        />
      </a>
    </div>
    <div class="home-notice">
      <p class="home-notice-em">本页面的下载资源适用的洪恩智能学习机。</p>
    </div>
    <div class="home-breadcrumbs">
      <a href="/">洪恩教育</a> &gt; <a href="/downloads">下载中心</a> &gt; 洪恩智能学习机 资源下载
    </div>
    <p class="home-title">固件下载</p>
    <table class="home-firmware">
      <thead>
        <tr>
          <th>下载</th>
          <th>版本</th>
          <th>主控版本</th>
          <th>文件大小</th>
          <th>说明</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(firmware, index) of firmwareList"
          :key="index"
        >
          <td class="home-firmware-download">
            <a
              :href="firmware.version_url"
              target="_blank"
            >
              下载
            </a>
          </td>
          <td class="home-firmware-version">
            {{ firmware.version }}
          </td>
          <td class="home-firmware-type">
            {{ firmware.version_type }}
          </td>
          <td class="home-firmware-size">
            {{ byteToMegaByte(firmware.version_length) }}MB
          </td>
          <td class="home-firmware-description">
            {{ firmware.description }}
          </td>
        </tr>
      </tbody>
    </table>
    <p class="home-title">资源下载</p>
    <div class="home-series">
      <label for="seriesSelect" class="home-series-left">
        科目：
        <select
          v-model="currentSubject"
          name="seriesSelect"
          @change="selectSubject"
        >
          <option value="">全部</option>
          <option
            v-for="(subject, index) of subjectList"
            :key="index"
            :value="subject"
          >
            {{ subject }}
          </option>
        </select>
      </label>
      <label for="resourceName" class="home-series-right">
        资源名称：
        <input
          v-model="resourceName"
          name="resourceName"
          type="text"
        />
        <button
          @click="searchResource"
        >
          搜索
        </button>
      </label>
    </div>
    <table class="home-books">
      <thead>
        <tr>
          <th>下载</th>
          <th>文件名</th>
          <th>文件大小</th>
          <th>文件描述</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(resource, index) of resourceListResult.list"
          :key="index"
        >
          <td class="home-books-download">
            <a
              :href="resource.resourceUrl"
              target="_blank"
            >
              下载
            </a>
          </td>
          <td class="home-books-name">
            {{ resource.filename }}
          </td>
          <td class="home-books-size">
            {{ byteToMegaByte(resource.resourceLength) }}MB
          </td>
          <td>
            {{ resource.name }}
          </td>
        </tr>
      </tbody>
    </table>
    <div>
      <div class="button-group">
        <button
          :disabled="resourceListResult.currentPage === 1"
          @click="goFirstPage"
        >
          &lt;&lt;
        </button>
        <button
          :disabled="resourceListResult.currentPage === 1"
          @click="goPrevPage"
        >
          &lt;
        </button>
        <span>
          {{ resourceListResult.currentPage }} / {{ resourceListResult.totalPage }}
        </span>
        <button
          :disabled="resourceListResult.currentPage === resourceListResult.totalPage"
          @click="goNextPage"
        >
          &gt;
        </button>
        <button
          :disabled="resourceListResult.currentPage === resourceListResult.totalPage"
          @click="goLastPage"
        >
          &gt;&gt;
        </button>
      </div>
    </div>
    <div class="home-footer">
      <p>© 1996-2023 北京金洪恩教育科技有限公司. All Rights Reserved.</p>
      <p>
        <a href="http://www.beian.miit.gov.cn" target="_blank">京ICP备20018943号-2</a>
        <span>京公网安备11010802020328号</span>
        <span>出版物经营许可证，新出发京批字第直190305号</span>
      </p>
    </div>
  </div>
</template>

<script>
import api from '@/lib/api';

export default {
  name: 'HomeView',
  data() {
    return {
      subjectList: [],
      currentSubject: '',
      resourceListResult: {
        currentPage: 1,
        list: [],
        pageSize: 10,
        total: 0,
        totalPage: 0,
      },
      firmwareList: [],
      resourceName: '',
    };
  },
  mounted() {
    api.getSubjectList().then((res) => {
      this.subjectList = res.data;
    });
    api.getFirmwareList().then((res) => {
      this.firmwareList = res.data || [];
    });
    this.getResourceList(this.currentSubject, this.resourceName, this.resourceListResult.currentPage);
  },
  methods: {
    getResourceList(series, keyword, page) {
      api.getResourceList(series, keyword, page).then((res) => {
        if (res.code === 200) {
          if (res.data) {
            this.resourceListResult.currentPage = res.data.current_page || 1;
            this.resourceListResult.firstPageFlag = res.data.first_page_flag;
            this.resourceListResult.lastPageFlag = res.data.last_page_flag;
            this.resourceListResult.list = res.data.list || [];
            this.resourceListResult.nextPageFlag = res.data.next_page_flag;
            this.resourceListResult.pageSize = res.data.page_size;
            this.resourceListResult.previousPageFlag = res.data.previous_page_flag;
            this.resourceListResult.total = res.data.total;
            this.resourceListResult.totalPage = res.data.total_page || 1;
          }
        }
      });
    },
    goFirstPage() {
      this.getResourceList(this.currentSubject, this.resourceName, 1);
    },
    goLastPage() {
      if (this.resourceListResult.totalPage === 0) {
        return;
      }
      this.getResourceList(this.currentSubject, this.resourceName, this.resourceListResult.totalPage);
    },
    goPrevPage() {
      if (this.currentPage === 1) {
        return;
      }
      this.getResourceList(this.currentSubject, this.resourceName, this.resourceListResult.currentPage - 1);
    },
    goNextPage() {
      if (this.currentPage === this.resourceListResult.totalPage) {
        return;
      }
      this.getResourceList(this.currentSubject, this.resourceName, this.resourceListResult.currentPage + 1);
    },
    searchResource() {
      this.currentSubject = '';
      this.getResourceList(this.currentSubject, this.resourceName, 1);
    },
    selectSubject() {
      this.resourceName = '';
      this.getResourceList(this.currentSubject, this.resourceName, 1);
    },
    byteToMegaByte(byte) {
      return (byte / 1024 / 1024).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  font-size: 14px;
  margin: 10px auto;
  max-width: 1170px;
  text-align: left;

  &-nav {
    height: 60xp;

    a {
      color: #333;
      display: inline-block;
      height: 60px;
      line-height: 60px;
      margin-right: 10px;
      padding: 0 10px;
      text-decoration: none;

      img {
        height: 40px;
        margin-right: 10px;
        vertical-align: middle;
      }
    }
  }

  &-notice {
    background-color: #F8EDA3;
    box-shadow: 0 1px 3px #C7A27A;

    &>p {
      margin: 4px;

      &>a {
        color: #A8760B;
        text-decoration: underline;
        font-weight: bold;
      }
    }

    &-em {
      font-weight: bold;
    }
  }

  &-breadcrumbs {
    color: #333;
    margin: 10px 0;

    &>a {
      color: #333;
      text-decoration: none;
    }
  }

  &-series {
    margin: 10px 0;

    &>label {
      margin-bottom: 10px;
    }

    &-left {
      float: left;
    }

    &-right {
      float: right;
    }

    select {
      border: 1px solid #ccc;
      border-radius: 3px;
      height: 24px;
      padding: 0 3px;
      max-width: 200px;
    }

    input {
      border: 1px solid #ccc;
      border-radius: 3px;
      height: 22px;
      margin-right: 10px;
      width: 140px;
    }

    button {
      background-color: #ddd;
      border: 1px solid #ccc;
      border-radius: 3px;
      color: #333;
      height: 30px;
      width: 48px;
    }
  }

  &-title {
    font-size: 18px;
    font-weight: bold;
    margin: 20px 0 10px 0;
  }

  &-books, &-firmware {
    border-collapse: collapse;
    width: 100%;

    &>thead {
      font-weight: bold;

      &>tr {
        &>th {
          border: 1px solid #ccc;
          padding: 5px 10px;
          text-align: center;
        }
      }
    }

    &>tbody {
      &>tr {
        &>td {
          border: 1px solid #ccc;
          padding: 5px 10px;
        }
      }
    }

    &-download {
      text-align: center;
      width: 50px;

      &>a {
        color: #333;
        text-decoration: none;

        &:hover {
          background-color: #ddd;
        }
      }
    }

    &-name {
      width: 70px;
      text-align: center;
    }

    &-size {
      text-align: right;
      width: 80px;
    }

    &-version {
      text-align: center;
      width: 60px;
    }

    &-type {
      padding: 5px;
      text-align: center;
      width: 60px;
    }

    &-description {
      white-space: pre-line;
    }
  }

  &-footer {
    margin: 20px 0;
    text-align: left;

    a {
      color: #333;
      display: inline-block;
      margin-right: 20px;
      text-decoration: none;
    }

    span {
      display: inline-block;
      margin-right: 20px;
    }
  }
  .button-group {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;

    button {
      background-color: #ddd;
      border: 1px solid #ccc;
      color: #333;
      margin: 0 5px;

      &:disabled {
        background-color: #eee;
        border-color: #eee;
        color: #ccc;
      }
    }
  }
}
</style>
